import clsx from 'clsx'
import * as React from 'react'
import { classToFComponent, FCClassContext } from 'src/3rds/cube-react'

import { makeStyles } from 'tss-react/mui'


import { UserProfileScope } from '../up_scopes'

const useStyles = makeStyles()({
    view: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        padding: 10,
        minHeight: 600,
        rowGap: 10
    },
    cnpjInput: {
        flexGrow: 1
    },
    syncButton: {
        alignSelf: 'center'
    },
    min600Height: {
        minHeight: 600
    }
})

type UserProfileViewProps = {
    className?: string
    scope: UserProfileScope
}

class UserProfileClass implements FCClassContext<UserProfileViewProps> {

    // :: Fields
    scope!: UserProfileScope
    sytles!: ReturnType<typeof useStyles>
    nameFilterInputRef!: React.MutableRefObject<HTMLInputElement | undefined>

    // :: Methods

    onSyncState({ scope }: UserProfileViewProps) {
        this.scope = scope
        this.sytles = useStyles()
    }

    render({ className }: UserProfileViewProps) {
        this.nameFilterInputRef = React.useRef<HTMLInputElement>()
        const classes = this.sytles.classes

        return (
            <div className={clsx(classes.view, className)}>
                <span>Profile</span>
            </div>
        )
    }
}

export const UserProfileView = classToFComponent(UserProfileClass, React)
export default UserProfileView
